var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTranslate = function SvgTranslate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "translate_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#translate_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "m12.666 15.563-.692 1.937a.739.739 0 0 1-.276.36.724.724 0 0 1-.427.14.713.713 0 0 1-.636-.333.737.737 0 0 1-.072-.709l2.979-7.937a.902.902 0 0 1 .3-.375.733.733 0 0 1 .44-.146h.602c.16 0 .307.049.44.146a.902.902 0 0 1 .301.375l3 7.958a.69.69 0 0 1-.091.698.745.745 0 0 1-.632.323.746.746 0 0 1-.454-.146.794.794 0 0 1-.281-.375l-.667-1.916h-3.834Zm.5-1.376H16l-1.38-3.937h-.078l-1.375 3.938ZM7.5 11.563l-3.458 3.416a.681.681 0 0 1-.521.219.758.758 0 0 1-.521-.24.718.718 0 0 1-.23-.52c0-.195.077-.369.23-.521l3.48-3.438c-.5-.528-.966-1.076-1.397-1.646-.43-.57-.805-1.187-1.125-1.854h1.716c.245.445.527.861.847 1.25.32.39.646.771.979 1.146a19.05 19.05 0 0 0 1.458-1.823A9.194 9.194 0 0 0 10.042 5.5H1.75a.728.728 0 0 1-.534-.214A.72.72 0 0 1 1 4.754c0-.21.072-.39.216-.535A.72.72 0 0 1 1.75 4h5V2.75c0-.212.071-.39.214-.534A.72.72 0 0 1 7.496 2c.21 0 .39.072.535.216a.72.72 0 0 1 .219.534V4h5c.213 0 .39.071.534.214a.72.72 0 0 1 .216.532c0 .21-.072.39-.216.535a.72.72 0 0 1-.534.219h-1.616a9.86 9.86 0 0 1-1.28 2.656 21.728 21.728 0 0 1-1.833 2.323l1.896 1.875-.584 1.542L7.5 11.562Z"
  }))));
};
export default SvgTranslate;